module.exports = __webpack_public_path__ + "static/media/Tile Image UTH 2176-2 (1).781c014c.jpg";